module.exports = __webpack_public_path__ + "img/sichakti_bagan_no.1560976c.png";